import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { getDelPrice, getLowerPrice, getProductUrl, isPromotion } from '../../../../../../../utils/product'
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants'
import CountDown from '../../components/count-down'
import Money from '../../components/money'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import CartIcon from '../../../../../listing/components/cart/cart-icon'

export const SizeColor = props => {
    useStyles(classes)
	const { size, color } = props
	const sizeColor = [color, size].filter(s => !!s).join(' / ')
	return <span className={classes.SizeColor} {...props}>{sizeColor}</span>
}

export const GiftItem = props => {
    useStyles(classes)
    const {item, serverTime = 0, isInCart} = props
	const isPromotion = (item?.itemPrice?.amount || 0) - (item?.realPrice?.amount || 0) > 0

	let off
	if (isPromotion) {
		off = Math.round((Number(item.itemPrice.amount) - Number(item.realPrice.amount)) * 100 / Number(item.itemPrice.amount))
	}

	const itemEdit = (item) => {
		if (window.GeekoSensors) {
			window.GeekoSensors.Track('CartAction', {
				action: "ClickColor"
			})
		}
		props.itemEdit({...item, getGiftWay:'PROMOTIONAL_ACTIVITY', isGift: item.present})
	}

	const detailUrl = () => {
		const _url = getProductUrl(props.item.productId,  props.item.productName)
		return _url+"?product_type=gift"
	}

	const money = isInCart ? props.item?.realPrice: props.item?.giftPrice

	return <div className={classes.GiftProductBox}>
			<div className={classes.ItemWrapper}>
				<div className={classes.ImageContainer}>
					<a href={detailUrl()} >
						<img className={classes.Image} src={props.item.imageUrl} />
					</a>
					{
						false && item?.expirationTime > 0 && item?.expirationTime - serverTime > 0 &&
						<div className={classes.ExpirationTime}>
							<img src={`${IMAGE_GEEKO_LTD}/chicme/20220801/gift-clock.png`} alt="gift-clock" />
							<CountDown className={classes.CountDown} showHour offset={(item.expirationTime - serverTime)} />
						</div>
					}
				</div>

				<div className={classes.ItemContainer}>
					<div className={classes.ItemInfo}>
						<p className={classes.TxtEllipsis}>
							{props?.item?.productName}
						</p>


						<div className={classes.PriceBox}>
							{
								<React.Fragment>
									<span className={classes.MoneyBox}>
										<Money money={money} />
									</span>
								</React.Fragment>
							}
						</div>
					</div>


					{
						(!props.ivalidItem &&
						<div className={classes.ToolsBox}>
							<SizeColor onClick={(evt) => { itemEdit(props.item) }} size={props.item.size2 || props.item.size} color={props.item.color} />
							<Iconfont onClick={ (evt) => { props.itemDelete(props.item) }}>&#xe777;</Iconfont>
						</div>)
					}

				</div>
			</div>
	</div>
}

export const GiftSkeleton = props => {
	useStyles(classes)
    return <div className={classes.GiftSkeleton}>
			<a>
				<div></div>
				<div>
					<Iconfont>&#xe6a8;</Iconfont>
				</div>
			</a>
			<div className={classes.PricePart}>
				<div className={classes.Price}>
					<div></div>
				</div>
			</div>
	</div>
}

export const GiftProduct = props => {
	useStyles(classes)
    const {product, position, onSelect, iconOnImage, isGift, sensors, giftInfo, product_type} = props

    const [lower, higher, isProm] = [
		getLowerPrice(product),
		getDelPrice(product),
		isPromotion(product)
	]
	const promotionType = isProm ? product.promotion.type : ''

    return <div className={classes.ProductBox} onClick={evt => {
			    // onSelect(product.variants[0], product, position)
		    }}>
			<a className={classes.ProductImage} >
				<img src={`${IMAGE_GEEKO_LTD}/medium/${product.pcMainImage}`}/>
				{
					iconOnImage &&
					<div className={classes.IconOnImage}>
						<CartIcon
							sensors={{
								layerName: product?.layerName,
								promotionType,
								trackingRecords: product?.trackingRecords,
								dataSource: product?.dataSource,
								geekoExperimentId: product?.geekoExperimentId,
								geekoRequsestId: product?.geekoRequsestId,
								aliRequestId: product?.aliRequestId,
								aliExperimentId: product?.aliExperimentId,
								product_position: position + 1,
								...sensors
							}}
							isGift={isGift}
							giftInfo={giftInfo}
							product_type={product_type}
							productId={product.id}
							color={product?.variants?.[0]?.color}
							/>
					</div>
				}
			</a>

			{
				product.isNew && <span className={classes.Off}><FormattedMessage id="new"></FormattedMessage></span>
			}

			<div className={classes.ProductPrice}>
				<div className={classes.Price}>
					<Money style={{color:'#e64545', fontFamily: 'Roboto-Bold'}}
						money={product.giftPrice}/>
				</div>

			</div>
		</div>
}

